// Endpoints de produtividade — `/v1/metricas/produtividade/*` (MET-07..MET-11).
import { api } from '@/lib/api';
import type {
  Drilldown,
  MetricsCherryPickDto,
  MetricsConcurrencyDto,
  Segmented,
  WithEnvelope,
} from '../model';
import {
  metricsUrl,
  type MetricsListArgs,
  type MetricsQueryArgs,
  type MetricsSegmentArgs,
} from './shared';

export const metricsTeamApi = api.injectEndpoints({
  endpoints: (build) => ({
    /** MET-07 — atribuição por atendente. */
    metricsTeamAssignment: build.query<WithEnvelope<Segmented>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('produtividade/atribuicao', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    /** MET-07 — conversas que ninguém trabalhou. */
    metricsTeamUnworked: build.query<WithEnvelope<Drilldown>, MetricsListArgs>({
      query: (args) => metricsUrl('produtividade/nao-trabalhadas', { ...args }),
      providesTags: ['MetricsDrilldown'],
    }),
    /** MET-08 — quem escolhe as conversas de ticket alto. */
    metricsTeamCherryPick: build.query<WithEnvelope<MetricsCherryPickDto>, MetricsQueryArgs>({
      query: (args) => metricsUrl('produtividade/cherry-picking', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    /** MET-09 — conversas abertas simultâneas por atendente. */
    metricsTeamConcurrency: build.query<WithEnvelope<MetricsConcurrencyDto>, MetricsQueryArgs>({
      query: (args) => metricsUrl('produtividade/simultaneidade', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    /** MET-10 — transferências entre atendentes. */
    metricsTeamTransfers: build.query<WithEnvelope<Segmented>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('produtividade/transferencias', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    metricsTeamTransferList: build.query<WithEnvelope<Drilldown>, MetricsListArgs>({
      query: (args) => metricsUrl('produtividade/transferencias/lista', { ...args }),
      providesTags: ['MetricsDrilldown'],
    }),
    /** MET-11 — tempo logado / sessões de atendimento. */
    metricsTeamSessions: build.query<WithEnvelope<Segmented>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('produtividade/sessoes', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useMetricsTeamAssignmentQuery,
  useMetricsTeamUnworkedQuery,
  useMetricsTeamCherryPickQuery,
  useMetricsTeamConcurrencyQuery,
  useMetricsTeamTransfersQuery,
  useMetricsTeamTransferListQuery,
  useMetricsTeamSessionsQuery,
} = metricsTeamApi;
